<div *ngIf="authUser$ | async; let authUser" class="user-select-wrapper" fxLayout="column" fxFlex="0 0 100%">
    <app-table-filter [filtersTogglesInOnBtn]="true" [inGlobalFilter]="true" color="accent" #filter>
        <app-table-search [inGlobalFilter]="true" class="align-space" searchFilterRef></app-table-search>
        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Academy Roles"
            i18n-label="@@academyRoles"
            [property]="GlobalFilterProperty.USER_ROLE"
            [options]="userRoleOptions"
            userRolesRef
        >
        </app-select-filter>

        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Status"
            i18n-label="@@status"
            [property]="{ name: GlobalFilterProperty.STATUS, type: GlobalFilterPropertyType.STATUS_USER }"
            [options]="userStatusOptions"
            userStatusRef
        >
        </app-select-filter>
        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Filter by selection"
            i18n-label="@@filterBySelection"
            [property]="GlobalFilterProperty.SELECTED"
            [options]="itemSelectedOptions"
            selectedItemsRef
        >
        </app-select-filter>
    </app-table-filter>

    <div fxLayoutAlign="start center" fxLayoutGap="10px" class="selection-Info">
        <div fxLayoutAlign="start center" fxLayoutGap="5px" class="main">
            <span class="label"
                ><span i18n="@@numberOf">Number of</span>
                {{ AppScope.getScopeLabel(customer$, AppScope.USERS) | async }}:</span
            >
            <span class="total">{{ total }}</span>
        </div>
        <div fxLayoutAlign="start center" fxLayoutGap="5px" class="selected" *ngIf="selected">
            <span class="selectedNu" i18n="@@selected">Selected:</span>
            {{ selected }}
        </div>
    </div>
    <mat-progress-bar
        class="progress progress-table-loader"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    ></mat-progress-bar>
    <mat-table
        #table
        [dataSource]="dataSource"
        [matSortActive]="defaultSorting"
        (matSortChange)="onSortDataChages($event)"
        matSort
        [class.mobileView]="isMobile"
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="selectToggle(user)"
                    [checked]="modelChecked(user)"
                    [disabled]="user.disabled || (onCloseSelection | async)"
                >
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name"> Name </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span i18n="@@name" class="mobile-label"> Name </span>
                <span
                    [matTooltip]="(user | connectionStatus)?.label"
                    [ngStyle]="{
                        color: (user | connectionStatus)?.fg,
                        background: (user | connectionStatus)?.bg
                    }"
                    class="user-name {{ (user | connectionStatus)?.class }}"
                    >{{ user.name }}</span
                >
                <mat-icon
                    class="waiting"
                    *ngIf="!!user.waiting"
                    matTooltip="On Waiting List"
                    i18n-matTooltip
                    matTooltipPosition="above"
                    >pending</mat-icon
                >
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="username">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@username"> User name </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span i18n="@@username" class="mobile-label"> User name </span>
                {{ user.username }}</mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="group">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@group"> Group </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span i18n="@@group" class="mobile-label"> Group </span>
                {{ user.group?.name }}</mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="role_value">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@role"> Role </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span i18n="@@role" class="mobile-label"> Role </span>
                {{ user.role_value }}</mat-cell
            >
        </ng-container>

        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@email"> Email </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span i18n="@@email" class="mobile-label"> Email </span>
                {{ user.email }}</mat-cell
            >
        </ng-container>

        <ng-container matColumnDef="completed">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@completed"> Completed </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span class="mobile-label" i18n="@@completed"> Completed </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tools">
            <mat-header-cell *matHeaderCellDef i18n="@@tools"> Tools </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span class="mobile-label" i18n="@@tools"> Tools </span>
                <ng-container *ngIf="user.occasion">
                    <app-users-select-tools [user]="user"></app-users-select-tools>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customTools">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let resource">
                <ng-container *ngTemplateOutlet="customTools; context: { $implicit: resource }"></ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="started">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@started"> Started </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <span class="mobile-label" i18n="@@started"> Started </span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let user; columns: columns"
            [class.disable-row]="user.disabled"
            (click)="!user.disabled && selectToggle(user)"
        ></mat-row>
    </mat-table>

    <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
</div>
